export const CACHE_KEY_LIST_ORGANIZATION = 'organizations';
export const CACHE_KEY_ORGANIZATION = 'organization-one';
export const ROUTE_PATH_ORGANIZATION = '/configuration/organizations';
export const TRANSLATION_PREFIX_ORGANIZATION = 'organization';

